/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.

/*
 * EXPORTS
 */
export default gql`
  query KeywordDirectoryReadQuery($take: PositiveInt!, $skip: Int!) {
    KeywordDirectoryRead(take: $take, skip: $skip) {
      message,
      status,
      id,
      displayName,
      _totalCount
    }
  }
`
